import styled from 'styled-components';

import Icon from './icon';

export default styled.input.attrs(() => ({
  type: 'radio',
}))`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ ${Icon} {
    background-color: ${({ theme }) => theme.primaryColor};
    &:after {
      display: block;
    }
  }
`;
